import { Route } from 'react-resource-router';

import { Apps } from '@townsquare/app-context';
import { getConfig } from '@townsquare/config';
import { isGateEnabled } from '@townsquare/stat-sig/gate';

import type {
  AccessControlCapability,
  CapabilityContainer,
} from './CapabilityRouter/__generated__/CapabilityRouterFragment.graphql';
import type { RouteWithOutlet, RouteWithSubproduct, UserCapabilityType } from './types';

export function isRouteWithOutlet(route: Route): route is RouteWithOutlet {
  return Object.prototype.hasOwnProperty.call(route, 'type');
}

export function isRouteWithSubproduct(route: Route): route is RouteWithSubproduct {
  return Object.prototype.hasOwnProperty.call(route, 'subproduct');
}

export const getRoleFromCapability = (
  capabilityContainer: CapabilityContainer,
  capability: AccessControlCapability,
): UserCapabilityType => {
  return `${capabilityContainer.toLowerCase()}:${capability.toLowerCase()}` as UserCapabilityType;
};

export const ORG_SITE_ROUTE_REGEX = new RegExp(
  `^/o/(?<orgIdentifier>[0-9a-zA-Z-]+)(/s/(?<siteIdentifier>[a-zA-Z0-9%+-]+))*`,
);

// Strips the URL to get route path
// eg. `https://home.stg.atlassian.com/o/{orgId}/s/{siteId}/goals/{extra}` to `/goals/{extra}`
export const getRoutePathFromUrl = (url: string) =>
  url.replace(getConfig().fullUrl, '').replace(ORG_SITE_ROUTE_REGEX, '');

export const isGoalsAppRoute = (url: string) => {
  if (!isGateEnabled('atlas_goals_app_enabled')) {
    return false;
  }

  return getRoutePathFromUrl(url).startsWith('/goal');
};

/**
  TODO: Enable for teams
  export const isTeamsAppRoute = (url: string) => {
    if (!isGateEnabled('atlas_teams_app_enabled')) {
      return false;
    }

    return getRoutePathFromUrl(url).startsWith('/people');
  };
**/

/**
 *
 * @param route URL or path of a link ie. https://home.stg.atlassian.com/o/{orgId}/s/{siteId}/goals` or `/goals`
 * @param app App ie. Goals, Teams, Home
 * @returns if route belongs to app
 */
export const isRouteOfApp = (route: string, app: Apps) => {
  if (app !== 'goals' && isGoalsAppRoute(route)) {
    return false;
  }

  if (app === 'goals' && !isGoalsAppRoute(route)) {
    return false;
  }

  /**
    TODO: Enable for teams and home routes

    const hasNoWorkspace = useNoWorkspaceExperience();
    if (isTeamsAppRoute(pathName) && hasNoWorkspace) {
      return app !== 'teams';
    }

    return app !== 'home';
  **/

  return true;
};
